import React from 'react';
import { Popover, Skeleton, Spin } from 'antd';
import dayjs from 'dayjs';
import { InfoCircleOutlined } from '../Icons';
import FacilityTypeDeal from '@/utils/facilityTypeDeal';
import ParkingAtRangePicker from './ParkingAtRangePicker';
import BookingDetails from '@/components/BookingDetails';
import ParkingAtDateMonthly from './ParkingAtDateMonthly';
import ReserveNowButton from '../ReserveNowButton';
import RangePickerWithTime from '../RangePickerWithTime';
import { observer } from 'mobx-react-lite';

function ParkingAtSelectDate({
  dateRange,
  facility,
  textTotalPrice,
  handleChangeDatesModal,
  handleConfirmSetDateTimeModal,
  checkInSessionStorage,
  onDateChange,
  groupedDates,
  checkin,
  checkout,
  handleRangeChange,
  handleCheckingChange,
  setChangedDateTime,
  changedDateTime,
  isLoading,
  deviceType,
}) {
  return (
    <div className="md:border rounded-lg w-full md:max-w-[25rem] p-4">
      <div className="hidden md:flex flex-col text-end mb-4 space-y-2">
        {facility.facility_is_express_deal > 0 && (
          <p className="rounded-md h-5 w-40 text-center font-semibold text-sm italic text-white bg-secondary ml-auto mb-1.5">
            {FacilityTypeDeal(facility)}
          </p>
        )}
      </div>
      <div className="hidden md:flex">
        {facility.facilityParkingType == 4 ? (
          <ParkingAtDateMonthly
            setChangedDateTime={setChangedDateTime}
            dateRange={dateRange}
            hchangeCheckin={handleCheckingChange}
            changedDateTime={changedDateTime}
            deviceType="desktop"
            facility={facility}
          />
        ) : (
          <RangePickerWithTime
            checkin={checkin}
            checkout={checkout}
            isCity={facility.facilityParkingType == 2}
            onChange={handleRangeChange}
            deviceType={deviceType}
            isParkingAt
          />
        )}
      </div>
      {isLoading ? (
        <Spin tip="loading" className="mt-2" />
      ) : (
        <>
          <BookingDetails
            fromParkingAt={true}
            onDateChange={onDateChange}
            detailsFontSize="text-base"
            facility={facility}
            groupedDates={groupedDates}
            checkin={checkin}
            checkout={checkout}
          />

          <div className="flex justify-center">
            <ReserveNowButton
              facility={facility}
              handleChangeDatesModal={handleChangeDatesModal}
              handleConfirmSetDateTimeModal={handleConfirmSetDateTimeModal}
              extraClass="w-full"
            />
          </div>
        </>
      )}
    </div>
  );
}

export default observer(ParkingAtSelectDate);